import type { InvestTheme } from './types';

const THEME_PARAM_KEYS = [
  'accent',
  'background',
  'foreground',
  'muted',
  'mutedForeground',
  'border',
  'radius',
  'scheme',
] as const;

/**
 * Serializes theme values into `&accent=...&radius=...&scheme=...` for the
 * invest URL. Only non-empty string values are emitted, URI-encoded; there
 * is no further validation on purpose, since the invest app validates the
 * values and falls back server-side.
 */
export function buildThemeQuery(theme: InvestTheme | undefined): string {
  if (!theme) return '';
  let query = '';
  for (const key of THEME_PARAM_KEYS) {
    const value = theme[key];
    if (typeof value === 'string' && value.length > 0) {
      query += `&${key}=${encodeURIComponent(value)}`;
    }
  }
  return query;
}
